if (!customElements.get('cirelia-home-packs')) {
  customElements.define('cirelia-home-packs', class extends HTMLElement {
    connectedCallback() {
      const scope = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
      if (!scope) return;
      const packs = {
        m1AK: { name: 'Découverte', count: 4 },
        TXhW: { name: 'Rituel', count: 8, badge: 'PLUS POPULAIRE' },
        '51jj': { name: 'Grand Rituel', count: 12, badge: 'MEILLEURE OFFRE' }
      };
      const currency = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
      const amount = element => {
        const text = element?.textContent?.replace(/[^\d,.-]/g, '') || '';
        return text ? Number(text.includes(',') ? text.replace(/\./g, '').replace(',', '.') : text) : NaN;
      };
      const setText = (element, text) => {
        if (element && element.textContent !== text) element.textContent = text;
      };
      const update = () => {
        this.observer.disconnect();
        const block = scope.querySelector('.kaching-bundles__bars');
        if (block) {
          setText(scope.querySelector('.kaching-bundles__block-title'), 'CHOISISSEZ VOTRE RITUEL');
          block.querySelectorAll('[data-deal-bar-id]').forEach(bar => {
            const pack = packs[bar.dataset.dealBarId];
            if (!pack) return;
            setText(bar.querySelector('.kaching-bundles__bar-title'), pack.name);
            setText(bar.querySelector('.kaching-bundles__bar-subtitle'), `${pack.count} paires · ${pack.count / 2} semaines`);
            if (pack.badge) setText(bar.querySelector('.kaching-bundles__bar-most-popular__content'), pack.badge);
            const price = amount(bar.querySelector('.kaching-bundles__bar-price'));
            const fullPrice = amount(bar.querySelector('.kaching-bundles__bar-full-price'));
            if (Number.isFinite(price) && Number.isFinite(fullPrice) && fullPrice > price) {
              setText(bar.querySelector('.kaching-bundles__bar-label'), `Économisez ${currency.format((Math.round(fullPrice * 100) - Math.round(price * 100)) / 100)}`);
            }
          });
        }
        this.observer.observe(scope, { childList: true, subtree: true, characterData: true });
      };
      this.observer = new MutationObserver(update);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}
